import { Bet } from "src/types";

export const sort = (bets: Array<Bet>) => {
  return bets.sort(
    (a, b) => Math.max.apply(null, a.racers) - Math.max.apply(null, b.racers)
  );
};
